import { render, staticRenderFns } from "./RecruitTempDetail.vue?vue&type=template&id=656aefb0&scoped=true&"
import script from "./RecruitTempDetail.vue?vue&type=script&lang=js&"
export * from "./RecruitTempDetail.vue?vue&type=script&lang=js&"
import style0 from "./RecruitTempDetail.vue?vue&type=style&index=0&id=656aefb0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "656aefb0",
  null
  
)

export default component.exports